<icc-list [searchable]="true" [items]="glassTypeVariants"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectVariant($event)"
          [selected]="selectedVariant"
          ></icc-list>